const zip = zip => !zip || /[0-9]{2}-[0-9]{3}/.test(zip);

export default zip;
